const CONTRACTS = {
  STORAGE:'0x210591dCE0b376494b53C3449040ae4B8A31Bd4C',
  LOGIC:'0x725f656440Fe3b76e688DAe3d3eF8a0F794dc73b',
  INCOME:'0xAC29e5294d3A871C18226dF9b103f880eaeAae9D',
  POOLS:'0x73070DdfC17813b91A933921B38D2c2C211F6D20',
  USDT:'0x9e5aac1ba1a2e6aed6b32689dfcf62a509ca96f3',
  REWARD_TOKEN:'0x59e29a566b6A325EFCea20aA760e7DB838B578A0'
};
export default CONTRACTS;
